import React, { useState } from 'react';
import { Modal, Form, Select, DatePicker, Checkbox, message } from 'antd';
import { generateInternalReport } from '../../services/internalReportingService';

const { RangePicker } = DatePicker;

const GenerateReportModal = ({ visible, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      const res = await generateInternalReport({
        ...values,
        startDate: values.period[0].format('YYYY-MM-DD'),
        endDate: values.period[1].format('YYYY-MM-DD'),
      });

      if (res?.status) {
        message.success(res.message);
        form.resetFields();
        onSuccess && onSuccess();
        onClose();
      }
    } catch (err) {
      console.error('Validation failed:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Generate Internal Report"
      open={visible}
      onCancel={onClose}
      onOk={handleSubmit}
      okText="Generate"
      confirmLoading={loading}
      width={600}
    >
      <Form form={form} layout="vertical" initialValues={{ notify: true }}>
        <Form.Item
          name="reportType"
          label="Report Type"
          rules={[{ required: true, message: 'Please select a report type' }]}
        >
          <Select placeholder="Select report type">
            <Select.Option value="Financial">Financial Performance</Select.Option>
            <Select.Option value="Operational">Operational Metrics</Select.Option>
            <Select.Option value="Portfolio">Loan Portfolio Summary</Select.Option>
            <Select.Option value="Revenue">Revenue Analytics</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="period"
          label="Reporting Period"
          rules={[{ required: true, message: 'Please select reporting period' }]}
        >
          <RangePicker style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item name="branch" label="Branch / Region">
          <Select placeholder="All Branches (Default)" allowClear>
            <Select.Option value="Lagos">Lagos HQ</Select.Option>
            <Select.Option value="Abuja">Abuja Branch</Select.Option>
            <Select.Option value="PH">Port Harcourt Branch</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item name="product" label="Product Filter">
          <Select placeholder="All Products (Default)" allowClear>
            <Select.Option value="Loan">Loan</Select.Option>
            <Select.Option value="Card">Card</Select.Option>
            <Select.Option value="POS">POS</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default GenerateReportModal;
